import request from '@/axios';

//商品列表-sku管理-分页列表
export const getList = (current, size, params) => {
    return request({
        url: '/api/us/getSpuList',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        },
    });
};

//商品列表-获取商品大类
export const getProductCategories = () => {
    return request({
        url: '/api/us/getProductCategories',
        method: 'get',
    });
};

//商品列表-获取商品筛选项检索
export const getFilters = (commodityTypeTreeId) => {
    return request({
        url: '/api/us/getFilters',
        method: 'get',
        params: {
            commodityTypeTreeId: commodityTypeTreeId
        }
    });
};

//商品详情-获取商品Sku列表
export const getSkuList = (commodityId) => {
    return request({
        url: '/api/us/getSkuList',
        method: 'get',
        params: {
            masterId: commodityId
        }
    });
};

// //商品详情-生成滑块图片
// export const genCaptcha = (data) => {
//     return request({
//         url: '/api/us/genCaptcha',
//         method: 'post',
//         data: data
//     });
// };

// //商品详情-图片滑块校验
// export const genCaptchaCheck = (data) => {
//     return request({
//         url: '/api/us/check',
//         method: 'post',
//         data: data
//     });
// };

//商品详情-记录联系我们信息
export const saveContactUserRecord = (formData) => {
    return request({
        url: '/api/us/saveContactUserRecord',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        method: 'post',
        data: formData
    });
};

//搜索框-记录搜索词
export const saveSearchRedWord= (data) => {
    return request({
        url: '/api/us/saveSearchRedWord',
        method: 'post',
        data: data
    });
};


// 属性库管理-字典库
// export const dictList = row => {
//     return request({
//         url: '/blade-commodity/commodityProp/dictList',
//         method: 'post',
//         data: row,
//     });
// };